import { render } from "./NoButton.vue?vue&type=template&id=c39c4328&scoped=true"
import script from "./NoButton.vue?vue&type=script&lang=ts"
export * from "./NoButton.vue?vue&type=script&lang=ts"

import "./NoButton.vue?vue&type=style&index=0&id=c39c4328&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c39c4328"

export default script